import { Container } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import AppHeader from "@saleor/components/AppHeader";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import { FilterPageProps, ListProps, TabPageProps } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import { StoreDetailsFinance_storeDetailsFinance_edges_node } from "../../types/StoreDetailsFinance";
import { StoreDetailsFinanceList } from "../StoreDetailsFinanceList";
import {
  createFilterStructure,
  StoreDetailsFinanceFilterKeys,
  StoreDetailsFinanceFilterOpts
} from "./filters";

export interface StoreDetailsFinancePageProps
  extends ListProps,
    FilterPageProps<
      StoreDetailsFinanceFilterKeys,
      StoreDetailsFinanceFilterOpts
    >,
    TabPageProps {
  stores: StoreDetailsFinance_storeDetailsFinance_edges_node[];
  onBack: () => void;
  download: () => void;
}

export const StoreDetailsFinancePage: React.FC<StoreDetailsFinancePageProps> = ({
  currentTab,
  filterOpts,
  initialSearch,
  onSearchChange,
  onFilterChange,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  stores,
  currencySymbol,
  onBack,
  download,
  ...listProps
}) => {
  const intl = useIntl();
  const structure = createFilterStructure(intl, filterOpts);
  return (
    <>
      <Container>
        <AppHeader onBack={onBack}>
          {intl.formatMessage({
            defaultMessage: "Reports",
            description: "reports"
          })}
        </AppHeader>
        <PageHeader title="Store Details">
          <Button
            color="primary"
            variant="contained"
            disabled={!stores}
            onClick={download}
          >
            Download
          </Button>
        </PageHeader>

        <Card>
          <FilterBar
            allTabLabel={intl.formatMessage({
              defaultMessage: "All",
              description: "tab name"
            })}
            currencySymbol={currencySymbol}
            currentTab={currentTab}
            tabs={tabs}
            filterStructure={structure}
            searchPlaceholder={intl.formatMessage({
              defaultMessage: "Search by Legal Name"
            })}
            initialSearch={initialSearch}
            onSearchChange={onSearchChange}
            onFilterChange={onFilterChange}
            onAll={onAll}
            onTabChange={onTabChange}
            onTabDelete={onTabDelete}
            onTabSave={onTabSave}
          />

          <StoreDetailsFinanceList stores={stores} {...listProps} />
        </Card>
      </Container>
    </>
  );
};

export default StoreDetailsFinancePage;
